<template>
  <div class="menu-bar-container">
         <!-- :style="logoColor" -->
    <div class="logo"
         style="background:#3c8dbc"
         v-if="!collapse">
      <span class="logonLink"
            @click="path('')">{{titleName?titleName:''}}</span>
    </div>
    <div :class="!collapse?'outer-container':'outer-container1'">
      <el-menu ref="navmenu"
               class="el-menu-vertical-demo"
               background-color="#f6fbff"
               text-color="#4a4a4a"
               active-text-color="#4199cc"
               :collapse="collapse"
               :unique-opened="true "
               :collapse-transition="false"
               style="font-weight:600"
               @open="handleOpen"
               @close="handleClose"
               @select="handleselect">
        <div class="personal"
             v-if="!collapse">
          <div>
            <img src="@/assets/images/by.png"
                 class="personalImg"
                 @click="personal()">
          </div>
          <div class="desc"
               style="color:black">
            <p style="margin:0 0 10px 0">{{username}}</p>
            <div class="btn">
              <!-- <div class="btn-item">
                <div style="height:10px;width:10px;border-radius:10px;background:green;display:inline-block"></div>
                <span>&nbsp;&nbsp;在线</span>
              </div> -->
              <div class="btn-item"
                   @click="loding?'':Out()">
                <div style="height:10px;width:10px;display:inline-block;">
                  <span class="el-icon-switch-button"
                        style="font-size:10px;color:red">
                  </span>
                </div>
                <span>&nbsp;&nbsp;注销</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="collapse">
          <img src="@/assets/images/by.png"
               style="height:35px;width:35px;margin-top:15px;border-radius:35px;cursor:pointer"
               @click="personal()">
        </div>
        <div v-for="menu of menuList"
             :key="menu.menu_id"
             :class="collapse?'menu-item-hidden':'menu-item-all'">
          <el-submenu v-if="menu.item&&menu.item.length>=1"
                      :index="''+menu.menu_id"
                      style="position:relative">
            <template slot="title">
              <i v-if="menu.menu_name == '基础档案'">
                <!-- <span class="iconfont icon"
                      :class="menu.label"></span> -->
                <img class="iconimg" src="@/assets/images/基础档案 (1).png">
              </i>
              <i v-else-if="menu.menu_name == '报表管理'">
                <img class="iconimg" src="@/assets/images/基础档案 (1).png">
              </i>
              <i v-else>
                <img class="iconimg" src="@/assets/images/基础档案.png">
              </i>
              <span>&nbsp;&nbsp;{{menu.menu_name}}</span>
            </template>
            <template v-for="child of menu.item">
                <el-submenu v-if="child.item&&child.item.length"
                            :index="child.menu_id"
                            :key="child.menu_id"
                            style="position:relative">
                  <template slot="title">
                    <i>
                      <img class="iconimg" src="@/assets/images/基础档案.png">
                    </i>
                    <span>{{child.menu_name}}</span>
                  </template>
                  <el-menu-item v-for="itemchild of child.item"
                                  :key="itemchild.menu_id"
                                  :index="itemchild.menu_id"
                                  @click="path(itemchild.path,itemchild)"
                                  style="text-align:left">
                      <template slot="title">
                        <!-- 基础档案 -->
                        <i v-if="itemchild.menu_name == '部门管理'" class="marLift">
                          <img v-if="activeTab != '部门管理'" class="iconimg" src="@/assets/images/工序类别.png">
                          <img v-else class="iconimg" src="@/assets/images/菜单.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '离职员工'" class="marLift">
                          <img v-if="activeTab != '离职员工'" class="iconimg" src="@/assets/images/员工维护.png">
                          <img v-else class="iconimg" src="@/assets/images/用户2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '职位列表'" class="marLift">
                          <img v-if="activeTab != '职位列表'" class="iconimg" src="@/assets/images/职位列表.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '区域管理'" class="marLift">
                          <img v-if="activeTab != '区域管理'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '往来单位类型'" class="marLift">
                          <img v-if="activeTab != '往来单位类型'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '仓库'" class="marLift">
                          <img v-if="activeTab != '仓库'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '物料表'" class="marLift">
                          <img v-if="activeTab != '物料表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '物料成本'" class="marLift">
                          <img v-if="activeTab != '物料成本'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '小车车辆表'" class="marLift">
                          <img v-if="activeTab != '小车车辆表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '车辆进出记录'" class="marLift">
                          <img v-if="activeTab != '车辆进出记录'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '单位信用额度'" class="marLift">
                          <img v-if="activeTab != '单位信用额度'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '单位常用联系人'" class="marLift">
                          <img v-if="activeTab != '单位常用联系人'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '单位自有车辆表'" class="marLift">
                          <img v-if="activeTab != '单位自有车辆表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '学历维护'" class="marLift">
                          <img v-if="activeTab != '学历维护'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '返利策略表'" class="marLift">
                          <img v-if="activeTab != '返利策略表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <!-- 销售管理 -->
                        <i v-else-if="itemchild.menu_name == '基础价格本'" class="marLift">
                          <img v-if="activeTab != '基础价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '客户授权区域'" class="marLift">
                          <img v-if="activeTab != '客户授权区域'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '客户区域加价'" class="marLift">
                          <img v-if="activeTab != '客户区域加价'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '客户项目价格'" class="marLift">
                          <img v-if="activeTab != '客户项目价格'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '区域价格本'" class="marLift">
                          <img v-if="activeTab != '区域价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '区域加价表'" class="marLift">
                          <img v-if="activeTab != '区域加价表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '项目价格本'" class="marLift">
                          <img v-if="activeTab != '项目价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <!-- 库存管理 -->
                        <i v-else-if="itemchild.menu_name == '产成品入库'" class="marLift">
                          <img v-if="activeTab != '产成品入库'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '产成品退货'" class="marLift">
                          <img v-if="activeTab != '产成品退货'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '其他入库'" class="marLift">
                          <img v-if="activeTab != '其他入库'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '其他出库单'" class="marLift">
                          <img v-if="activeTab != '其他出库单'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '材料出库单'" class="marLift">
                          <img v-if="activeTab != '材料出库单'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '材料退货单'" class="marLift">
                          <img v-if="activeTab != '材料退货单'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <!-- <i v-else-if="itemchild.menu_name == '销售订单列表'" class="marLift">
                          <img v-if="activeTab != '销售订单列表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/字典2.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '销售一次过磅'" class="marLift">
                          <img v-if="activeTab != '销售一次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '销售二次过磅'" class="marLift">
                          <img v-if="activeTab != '销售二次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '今日记录'" class="marLift">
                          <img v-if="activeTab != '今日记录'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '销售出库单'" class="marLift">
                          <img v-if="activeTab != '销售出库单'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i> -->
                        <!-- 采购管理 -->
                        <!-- <i v-else-if="itemchild.menu_name == '采购订单管理'" class="marLift">
                          <img v-if="activeTab != '采购订单管理'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '送货单列表'" class="marLift">
                          <img v-if="activeTab != '送货单列表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '一次过磅'" class="marLift">
                          <img v-if="activeTab != '一次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '二次过磅'" class="marLift">
                          <img v-if="activeTab != '二次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '采购入库单'" class="marLift">
                          <img v-if="activeTab != '采购入库单'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i>
                        <i v-else-if="itemchild.menu_name == '采购称重表'" class="marLift">
                          <img v-if="activeTab != '采购称重表'" class="iconimg" src="@/assets/images/计件清单.png">
                          <img v-else class="iconimg" src="@/assets/images/档案.png">
                        </i> -->
                        <span>{{itemchild.menu_name}}</span>
                      </template>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item v-else
                              :key="child.menu_id"
                              :index="child.menu_id"
                              @click="path(child.path,child)"
                              style="text-align:left">
                  <template slot="title">
                    <i v-if="child.menu_name == '角色管理'" class="marLift">
                      <img v-if="activeTab != '角色管理'" class="iconimg" src="@/assets/images/角色管理.png">
                      <img v-else class="iconimg" src="@/assets/images/角色.png">
                    </i>
                    <i v-else-if="child.menu_name == '用户'" class="marLift">
                      <img v-if="activeTab != '用户'" class="iconimg" src="@/assets/images/用户.png">
                      <img v-else class="iconimg" src="@/assets/images/用户2.png">
                    </i>
                    <i v-else-if="child.menu_name == '字典'" class="marLift">
                      <img v-if="activeTab != '字典'" class="iconimg" src="@/assets/images/字典.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '枚举维护'" class="marLift">
                      <img v-if="activeTab != '枚举维护'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/维护.png">
                    </i>
                    <i v-else-if="child.menu_name == '组织列表'" class="marLift">
                      <img v-if="activeTab != '组织列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <!-- 微信管理 -->
                    <i v-else-if="child.menu_name == '微信用户'" class="marLift">
                      <img v-if="activeTab != '微信用户'" class="iconimg" src="@/assets/images/用户.png">
                      <img v-else class="iconimg" src="@/assets/images/微信.png">
                    </i>
                    <i v-else-if="child.menu_name == '微信公告栏'" class="marLift">
                      <img v-if="activeTab != '微信公告栏'" class="iconimg" src="@/assets/images/字典.png">
                      <img v-else class="iconimg" src="@/assets/images/字典.png">
                    </i>
                    <!-- 基础档案 -->
                    <i v-else-if="child.menu_name == '部门管理'" class="marLift">
                      <img v-if="activeTab != '部门管理'" class="iconimg" src="@/assets/images/工序类别.png">
                      <img v-else class="iconimg" src="@/assets/images/菜单.png">
                    </i>
                    <!-- 
                    <i v-else-if="child.menu_name == '离职员工'" class="marLift">
                      <img v-if="activeTab != '离职员工'" class="iconimg" src="@/assets/images/员工维护.png">
                      <img v-else class="iconimg" src="@/assets/images/用户2.png">
                    </i>
                    <i v-else-if="child.menu_name == '职位列表'" class="marLift">
                      <img v-if="activeTab != '职位列表'" class="iconimg" src="@/assets/images/职位列表.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i> -->
                    <i v-else-if="child.menu_name == '员工维护'" class="marLift">
                      <img v-if="activeTab != '员工维护'" class="iconimg" src="@/assets/images/员工维护.png">
                      <img v-else class="iconimg" src="@/assets/images/用户2.png">
                    </i>
                    <i v-else-if="child.menu_name == '区域管理'" class="marLift">
                      <img v-if="activeTab != '区域管理'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                      <i v-else-if="child.menu_name == '单位常用地址'" class="marLift">
                        <img v-if="activeTab != '单位常用地址'" class="iconimg" src="@/assets/images/计件清单.png">
                        <img v-else class="iconimg" src="@/assets/images/档案.png">
                      </i>
                      <i v-else-if="child.menu_name == '单位运输车辆'" class="marLift">
                        <img v-if="activeTab != '单位运输车辆'" class="iconimg" src="@/assets/images/计件清单.png">
                        <img v-else class="iconimg" src="@/assets/images/档案.png">
                      </i>
                    <i v-else-if="child.menu_name == '往来单位类型'" class="marLift">
                      <img v-if="activeTab != '往来单位类型'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                      <i v-else-if="child.menu_name == '往来单位'" class="marLift">
                        <img v-if="activeTab != '往来单位'" class="iconimg" src="@/assets/images/计件清单.png">
                        <img v-else class="iconimg" src="@/assets/images/档案.png">
                      </i>
                      <i v-else-if="child.menu_name == '装卸地'" class="marLift">
                        <img v-if="activeTab != '装卸地'" class="iconimg" src="@/assets/images/计件清单.png">
                        <img v-else class="iconimg" src="@/assets/images/档案.png">
                      </i>
                    <i v-else-if="child.menu_name == '仓库'" class="marLift">
                      <img v-if="activeTab != '仓库'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '物料表'" class="marLift">
                      <img v-if="activeTab != '物料表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                      <i v-else-if="child.menu_name == '车辆档案'" class="marLift">
                        <img v-if="activeTab != '车辆档案'" class="iconimg" src="@/assets/images/计件清单.png">
                        <img v-else class="iconimg" src="@/assets/images/档案.png">
                      </i>
                    <i v-else-if="child.menu_name == '物料质量标准'" class="marLift">
                      <img v-if="activeTab != '物料质量标准'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '物料仓库配置'" class="marLift">
                      <img v-if="activeTab != '物料仓库配置'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '物料成本'" class="marLift">
                      <img v-if="activeTab != '物料成本'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '返利策略表'" class="marLift">
                      <img v-if="activeTab != '返利策略表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '产成品入库'" class="marLift">
                      <img v-if="activeTab != '产成品入库'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <!-- 销售管理 -->
                    <!-- <i v-else-if="child.menu_name == '基础价格本'" class="marLift">
                      <img v-if="activeTab != '基础价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '客户授权区域'" class="marLift">
                      <img v-if="activeTab != '客户授权区域'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '客户区域加价'" class="marLift">
                      <img v-if="activeTab != '客户区域加价'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '客户项目价格'" class="marLift">
                      <img v-if="activeTab != '客户项目价格'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '区域价格本'" class="marLift">
                      <img v-if="activeTab != '区域价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i> -->
                    <i v-else-if="child.menu_name == '客户价格本'" class="marLift">
                      <img v-if="activeTab != '客户价格本'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售订单列表'" class="marLift">
                      <img v-if="activeTab != '销售订单列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <!-- <i v-else-if="child.menu_name == '区域加价表'" class="marLift">
                      <img v-if="activeTab != '区域加价表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i> -->
                    <i v-else-if="child.menu_name == '销售一次过磅'" class="marLift">
                      <img v-if="activeTab != '销售一次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售二次过磅'" class="marLift">
                      <img v-if="activeTab != '销售二次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '今日记录'" class="marLift">
                      <img v-if="activeTab != '今日记录'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售出库单'" class="marLift">
                      <img v-if="activeTab != '销售出库单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售一次过磅(手输)'" class="marLift">
                      <img v-if="activeTab != '销售一次过磅(手输)'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售二次过磅(手输)'" class="marLift">
                      <img v-if="activeTab != '销售二次过磅(手输)'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <!-- 采购管理 -->
                    <i v-else-if="child.menu_name == '采购订单管理'" class="marLift">
                      <img v-if="activeTab != '采购订单管理'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '送货单列表'" class="marLift">
                      <img v-if="activeTab != '送货单列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '一次过磅'" class="marLift">
                      <img v-if="activeTab != '一次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '二次过磅'" class="marLift">
                      <img v-if="activeTab != '二次过磅'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购入库单'" class="marLift">
                      <img v-if="activeTab != '采购入库单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购称重表'" class="marLift">
                      <img v-if="activeTab != '采购称重表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '材料质检单'" class="marLift">
                      <img v-if="activeTab != '材料质检单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '一次过磅(手输)'" class="marLift">
                      <img v-if="activeTab != '一次过磅(手输)'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '二次过磅(手输)'" class="marLift">
                      <img v-if="activeTab != '二次过磅(手输)'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '长乐物料库存表'" class="marLift">
                      <img v-if="activeTab != '长乐物料库存表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '峡南物料库存表'" class="marLift">
                      <img v-if="activeTab != '峡南物料库存表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '调拨单'" class="marLift">
                      <img v-if="activeTab != '调拨单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <!-- <i v-else-if="child.menu_name == '材料出库单'" class="marLift">
                      <img v-if="activeTab != '材料出库单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i>
                    <i v-else-if="child.menu_name == '材料退货单'" class="marLift">
                      <img v-if="activeTab != '材料退货单'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/档案.png">
                    </i> -->
                    <!-- 充值管理 -->
                    <i v-else-if="child.menu_name == '充值政策'" class="marLift">
                      <img v-if="activeTab != '充值政策'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '充值明细'" class="marLift">
                      <img v-if="activeTab != '充值明细'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <!-- 结转管理 -->
                    <i v-else-if="child.menu_name == '客户月结转统计'" class="marLift">
                      <img v-if="activeTab != '客户月结转统计'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '单位月结转列表'" class="marLift">
                      <img v-if="activeTab != '单位月结转列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其他应收'" class="marLift">
                      <img v-if="activeTab != '其他应收'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其他应付'" class="marLift">
                      <img v-if="activeTab != '其他应付'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '付款表'" class="marLift">
                      <img v-if="activeTab != '付款表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <!-- 开票管理 -->
                    <i v-else-if="child.menu_name == '开票申请'" class="marLift">
                      <img v-if="activeTab != '开票申请'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '开票信息'" class="marLift">
                      <img v-if="activeTab != '开票信息'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <!-- 报表管理 -->
                    <i v-else-if="child.menu_name == '送货单报表'" class="marLift">
                      <img v-if="activeTab != '送货单报表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                     <i v-else-if="child.menu_name == '客户销售区域项目统计'" class="marLift">
                      <img v-if="activeTab != '客户销售区域项目统计'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购订单统计表'" class="marLift">
                      <img v-if="activeTab != '采购订单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售日报'" class="marLift">
                      <img v-if="activeTab != '销售日报'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售月报'" class="marLift">
                      <img v-if="activeTab != '销售月报'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售订单统计表'" class="marLift">
                      <img v-if="activeTab != '销售订单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '客户销售区域统计表'" class="marLift">
                      <img v-if="activeTab != '客户销售区域统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售占比表'" class="marLift">
                      <img v-if="activeTab != '销售占比表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <!-- <i v-else-if="child.menu_name == '销售占比表(每日)'" class="marLift">
                      <img v-if="activeTab != '销售占比表(每日)'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i> -->
                    <i v-else-if="child.menu_name == '采购单日报'" class="marLift">
                      <img v-if="activeTab != '采购单日报'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购单月报'" class="marLift">
                      <img v-if="activeTab != '采购单月报'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购入库单统计'" class="marLift">
                      <img v-if="activeTab != '采购入库单统计'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '采购单统计表'" class="marLift">
                      <img v-if="activeTab != '采购单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销货单统计表'" class="marLift">
                      <img v-if="activeTab != '销货单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '客户充值统计表'" class="marLift">
                      <img v-if="activeTab != '客户充值统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '销售出库单统计'" class="marLift">
                      <img v-if="activeTab != '销售出库单统计'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '产成品入库单统计'" class="marLift">
                      <img v-if="activeTab != '产成品入库单统计'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '产成品入库单明细'" class="marLift">
                      <img v-if="activeTab != '产成品入库单明细'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其它入库单统计表'" class="marLift">
                      <img v-if="activeTab != '其它入库单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其它入库单明细'" class="marLift">
                      <img v-if="activeTab != '其它入库单明细'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '材料出库单统计表'" class="marLift">
                      <img v-if="activeTab != '材料出库单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '材料出库单明细'" class="marLift">
                      <img v-if="activeTab != '材料出库单明细'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其它出库单统计表'" class="marLift">
                      <img v-if="activeTab != '其它出库单统计表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '其它出库单明细'" class="marLift">
                      <img v-if="activeTab != '其它出库单明细'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '应收款列表'" class="marLift">
                      <img v-if="activeTab != '应收款列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '应收款明细表'" class="marLift">
                      <img v-if="activeTab != '应收款明细表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '应付款列表'" class="marLift">
                      <img v-if="activeTab != '应付款列表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '应付款明细表'" class="marLift">
                      <img v-if="activeTab != '应付款明细表'" class="iconimg" src="@/assets/images/计件清单.png">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png">
                    </i>
                    <i v-else-if="child.menu_name == '流水明细'" class="marLift">
                      <img v-if="activeTab != '流水明细'" class="iconimg" src="@/assets/images/字典.png" alt="">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png" alt="">
                    </i>
                    <i v-else-if="child.menu_name == '日志'" class="marLift">
                      <img v-if="activeTab != '日志'" class="iconimg" src="@/assets/images/字典.png" alt="">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png" alt="">
                    </i>
                    <i v-else-if="child.menu_name == '生效价格本日志'" class="marLift">
                      <img v-if="activeTab != '生效价格本日志'" class="iconimg" src="@/assets/images/字典.png" alt="">
                      <img v-else class="iconimg" src="@/assets/images/字典2.png" alt="">
                    </i>
                    <span>{{child.menu_name}}</span>
                  </template>
                </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else
                        :index="''+menu.menu_id"
                        @click="path(menu.path,menu)" style="height: 40px;line-height:40px">
            <i v-if="menu.menu_name == '菜单管理'" >
              <!-- <span class="iconfont icon"
                    :class="menu.label"></span> -->
              <img v-if="activeTab != '菜单管理'" class="iconimg" src="@/assets/images/字典.png" alt="">
              <img v-else class="iconimg" src="@/assets/images/菜单.png" alt="">
            </i>
            <i v-else-if="menu.menu_name == '销售图表'" >
              <img v-if="activeTab != '销售图表'" class="iconimg" src="@/assets/images/字典.png" alt="">
              <img v-else class="iconimg" src="@/assets/images/字典2.png" alt="">
            </i>
            <span>&nbsp;&nbsp;{{menu.menu_name}}</span>
            <!-- <img v-if="menu.menu_name == '销售图表'" class="iconimg" src="@/assets/images/字典.png" alt=""> -->
          </el-menu-item>
        </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavBar',
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      menuList: state => state.app.menuList,
      logoColor: state => state.app.logoColor,
      navColor: state => state.app.navColor,
      fontColor: state => state.app.fontColor,
      TabList: state => state.tabs.TabList,
      activeTab: state => state.tabs.activeTab,
      keepAlive: state => state.tabs.keepAlive
    })
  },
  data () {
    return {
      username: (JSON.parse(localStorage.personal)).userName,
      loding: false,
      titleName:localStorage.titleName
    }
  },
  watch: {
    $route: 'handleRoute'
  },
  mounted () {
    this.handleRoute(this.$route)
  },
  methods: {
    path (path,menu) {
      this.$router.push('/index/' + path)
      if (!path) {
        this.handleRoute(this.$route)
      }
    },
    handleRoute (route) {
      if (route.path === '/index/refresh') {
        return
      }
      // tab标签页选中, 如果不存在则先添加
      let tab = this.TabList.filter(item => item.name === route.name)
      if (!tab.length) {
        let keepAlive = route.path.slice(route.path.lastIndexOf('/') + 1)
        let item = [{
          name: route.name,
          title: route.name,
          keepAlive: keepAlive.substring(0, 1).toUpperCase() + keepAlive.substring(1)
        }]
        this.$store.commit('updateTabList', this.TabList.concat(item))
      }
      this.$store.commit('updateActiveTab', route.name)
      this.$refs.navmenu.activeIndex = '' + route.meta.index
      this.$refs.navmenu.initOpenedMenu()
    },
    personal () {
      this.path('personal')
    },
    Out () {
      this.$confirm('即将退出系统，是否继续？', '提示', {
        type: 'warning'
      }).then(() => {
        this.loding = true
        this.$store.commit('loding', true)
        this.$api.login.out().then(res => {
          this.loding = false
          this.$store.commit('loding', false)
          if (res.code === 0) {
            localStorage.clear()
            this.$message({ message: res.msg, type: 'success' })
            localStorage.removeItem('token')
            // localStorage.removeItem('client')
            localStorage.removeItem('roleId')
            localStorage.removeItem('userButtonList')//用户菜单按钮权限
            this.$store.commit('RouterLoad', false)
            this.$router.push('/login')
            this.$store.commit('updateTabList', [])
            this.$store.commit('updateActiveTab', '')
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          localStorage.removeItem('token')
          localStorage.removeItem('roleId')
          this.$router.push('/login')
          this.loding = false
          this.$store.commit('loding', false)
        })
      })
    },
    handleOpen (key, keyPath) {

    },
    handleClose (key, keyPath) {

    },
    handleselect (key, keyPath) {

    }
  }
}
</script>
<style lang="stylus" scoped>
.menu-bar-container
  position absolute
  top 0
  left 0
  bottom 0
.marLift
 padding-right 5px
.icon
  margin 0 10px 0 2px
.iconimg 
 height 18px
 width 18px
 border 0
.logo
  height 50px
  line-height 50px
  color #fff
  font-size 20px
.logonLink
  cursor pointer
.personal
  padding 15px
  height 45px
  text-align left
  display flex
.personalImg
  width 45px
  height 45px
  border-radius 45px
  cursor pointer
.desc
  padding 5px 5px 5px 10px
  width 100px
  font-size 12px
  font-weight 600
.btn
  display flex
  justify-content space-between
  font-weight 100
.btn-item
  cursor pointer
.el-menu--collapse
  width 60px
  height 100%
.menu-item-hidden
  width 60px
  color #333
  overflow hidden
.menu-item-all
  text-align left
  color #333
  width 200px
</style>



// WEBPACK FOOTER //
// src/views/NavBar/NavBar.vue